import {
  COMMANDS_MENU_LIST_LOADED,
  LOAD_COMMANDS_MENU_LIST,
  COMMAND_MENU_DELETED,
  RESET_COMMANDS_MENU_LIST,
  SYNC_FAILED,
} from './actionTypes';
import { ICommandsMenu } from './types';

export const initialState = {
  error: null,
  loaded: false,
  syncing: false,
  commandsMenuList: [],
  commandMenuDeleted: false,
};

export const reducer = (state = initialState, action: { type: any; payload?: any }) => {
  switch (action.type) {
    case LOAD_COMMANDS_MENU_LIST:
      return { ...state, error: null, syncing: true };
    case COMMANDS_MENU_LIST_LOADED:
      return {
        ...state,
        error: null,
        commandsMenuList: action.payload,
        syncing: false,
        loaded: true,
      };
    case COMMAND_MENU_DELETED:
      return {
        ...state,
        commandsMenuList: state.commandsMenuList.filter(
          (commandMenu: ICommandsMenu) => commandMenu.menuId !== action.payload
        ),
      };
    case RESET_COMMANDS_MENU_LIST:
      return {
        ...state,
        error: null,
        commandsMenuList: [],
        commandMenuDeleted: false,
        loaded: false,
        syncing: false,
      };
    case SYNC_FAILED:
      return { ...state, syncing: false, error: action.payload };
    default:
      return state;
  }
};
